function getEpochTime(date) {
	return Math.round(date.getTime());
}

function getNowInEpochTime() {
	return getEpochTime(new Date());
}

function getDateFromEpoch(epoch) {
	return new Date(epoch);
}

//ideally these will then be populated by the equivalents for other languages for other regions from resource files
const threeLetterDays = [
	"Sun",
	"Mon",
	"Tue",
	"Wed",
	"Thu",
	"Fri",
	"Sat"
]

const threeLetterMonths = [
	"Jan",
	"Feb",
	"Mar", 
	"Apr", 
	"May", 
	"Jun", 
	"Jul", 
	"Aug", 
	"Sep", 
	"Oct", 
	"Nov", 
	"Dec"
]

function getDayAbbreviation(dayOfWeek, toUpper){

	if(toUpper === true){
		return threeLetterDays[dayOfWeek].toUpperCase();
	}
	return threeLetterDays[dayOfWeek];
}

function getMonthAbbreviation(month, toUpper){
	if(toUpper === true){
		return threeLetterMonths[month].toUpperCase();
	}
	return threeLetterMonths[month];
}

function getDateOrdinal(date) {
	if (date > 3 && date < 21) return 'th';
	switch (date % 10) {
	  case 1:  return "st";
	  case 2:  return "nd";
	  case 3:  return "rd";
	  default: return "th";
	}
  }

export {
	getEpochTime,
	getNowInEpochTime,
	getDateFromEpoch,
	getDayAbbreviation,
	getMonthAbbreviation,
	getDateOrdinal
}
